import { Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekMenu = styled(Menu)(({ theme }) => ({
    zIndex: 9999,
    "& .MuiPaper-root": {
        borderRadius: theme.spacing(0.3),
        boxShadow: `0px 0px ${theme.spacing(0.2)} ${theme.palette.grey[100]}, 0px 0px ${theme.spacing(0.1)} ${theme.palette.grey[100]}`,
        "& .MuiMenu-list": {
            padding: `${theme.spacing(0.4)} 0`,
        },
    },
}));

export { PeekMenu, PeekMenu as default };
